import React, { ReactNode } from 'react';

import styled from 'styled-components';

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-family: var(--font-bold);
  margin-bottom: 14px;
`;

const IconChip = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.pink {
    background-image: linear-gradient(to bottom, var(--pink-pale), var(--pink-soft));
  }

  &.mint {
    background-image: linear-gradient(to bottom, var(--mint-pale), var(--mint-soft));
  }

  &.blue {
    background-image: linear-gradient(to bottom, var(--blue-mist), var(--blue-sky));
  }

  &.lavender {
    background-image: linear-gradient(to bottom, var(--lavender-pale), var(--lavender-soft));
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

type Props = {
  icon: string;
  color: 'pink' | 'mint' | 'blue' | 'lavender';
  children: ReactNode;
};

const CommunitiesToWatchSectionHeader = ({ icon, color, children }: Props) => (
  <Header>
    <IconChip className={color}>
      <Icon src={icon} alt="" />
    </IconChip>
    {children}
  </Header>
);

export default CommunitiesToWatchSectionHeader;
